import React from "react";

import SectionItem from "./SectionItem";

import {
  ConditionIcon,
  ConditionIconWrapper,
  ConditionsWrapper,
  ConditionTitle,
  SectionList,
  StyledConditionHeader,
} from "./style";

const ConditionItem = ({ conditionTitle, sections }) => {
  const ConditionHeader = (
    <StyledConditionHeader>
      <ConditionIconWrapper>
        <ConditionIcon icon="icon-yogi" />
      </ConditionIconWrapper>
      <ConditionTitle variant="heading2">{conditionTitle}</ConditionTitle>
    </StyledConditionHeader>
  );

  return (
    <ConditionsWrapper>
      {ConditionHeader}
      <SectionList>
        {sections?.map((section) => (
          <SectionItem key={section.url} {...section} />
        ))}
      </SectionList>
    </ConditionsWrapper>
  );
};

export default ConditionItem;
